var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a-tree',{attrs:{"autoExpandParent":"","treeData":_vm.departTree,"selectedKeys":_vm.selectedKeys,"expandedKeys":_vm.iExpandedKeys},on:{"select":_vm.onSelect,"expand":_vm.onExpand}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }